/* eslint-disable react/prop-types */ // TODO: add props
import cx from 'classnames';
import { SafeHTML } from 'edrolo/domains/app';
import { getOptionLabelFromIndex } from '../../utils';
import s from './styles.scss';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

export const MultiSelector = ({
  answers,
  correctAnswers,
  selectedAnswerIds,
  onChange,
  isCorrect,
  disabled,
}) => {
  const isCorrectAnswer = (answerId) =>
    correctAnswers && correctAnswers.indexOf(answerId) > -1;
  const isIncorrectAnswer = (answerId) =>
    correctAnswers && correctAnswers.indexOf(answerId) === -1;

  return (
    <>
      <ul
        className={cx(s.options, { [s.disabled]: disabled })}
        data-test={`${disabled ? 'answer' : 'question'}-${
          EXAM_QUESTION_TYPES.SELECT_MULTI
        }`}
      >
        {answers.map((answer, index) => {
          const answerId = answer.get('id');
          const correct = isCorrectAnswer(answerId);
          const incorrect = isIncorrectAnswer(answerId);
          const selected = selectedAnswerIds?.some(
            (selectedAnswerId) => selectedAnswerId === answerId
          );

          // Questions with more than 26 options will not show labels
          const optionLabel = getOptionLabelFromIndex(index);

          return (
            <li
              key={answerId}
              className={cx(s.option, {
                [s.selected]: selected,
                [s.correct]: correct,
                [s.incorrect]: incorrect,
                [s.answeredCorrectly]: selected && correct,
                [s.answeredIncorrectly]: selected && incorrect,
              })}
              onClick={() => !disabled && onChange(answerId)}
              data-test="multi-choice-answer"
            >
              <div className={s.optionWrapper}>
                <span
                  className={cx(s.checkmark)}
                  data-test={
                    (correct && 'multi-choice-answer-correct',
                    incorrect && 'multi-choice-answer-incorrect')
                  }
                />
                <div className={s.optionLabel}>{optionLabel}</div>
              </div>
              <div className={s.html}>
                <SafeHTML>{answer.get('text')}</SafeHTML>
              </div>
            </li>
          );
        })}
      </ul>

      {selectedAnswerIds?.size > 0 && !isCorrect && (
        <div className={s.incorrectAnswer}>
          <div className={s.icon} />
          <p>Incorrect, you didn&lsquo;t select the correct answers.</p>
        </div>
      )}
    </>
  );
};
